__turbopack_context__.v({
  "reviewContent": "dLFEja_reviewContent",
  "reviewFooter": "dLFEja_reviewFooter",
  "reviewImage": "dLFEja_reviewImage",
  "reviewRepeat": "dLFEja_reviewRepeat",
  "reviewStars": "dLFEja_reviewStars",
  "reviewTitle": "dLFEja_reviewTitle",
  "reviewTopRow": "dLFEja_reviewTopRow",
  "root": "dLFEja_root",
});
